import React from "react";
import "./SubscriberInfoBar.css";

// children can be selectors or any controls
const SubscriberInfoBar = ({ name, accountNumber, email, address, children }) => (
  <div className="subscriber-info-bar-container">
    <div className="user-info-bar">
      <span>{name} | {accountNumber}</span>
      <span className="divider" />
      <span>Email <span className="info-value">{email}</span></span>
      <span className="divider" />
      <span>Address <span className="info-value">{address}</span></span>
    </div>
    {children && <div className="usage-select-bar">{children}</div>}
  </div>
);

export default SubscriberInfoBar;

